import React, { Fragment, useEffect, useRef, useState } from "react";
import "../../templateform/templateform.css";


function Domain(props) {
    const { setDomainSelectShow } = props;
    const wrapperRef = useRef(null);
    const [domainListShow, setDomainListShow] = useState(false)
    const [domainList, setDomainList] = useState(['viren.com', 'veer.com'])
    const [selectDomain, setSelectDomain] = useState([""])

    const handleCloseSetting = () => setDomainListShow('');
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                handleCloseSetting()
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const addNewDomain = () => {
        let newOdj = "";
        let newArr = [...selectDomain]
        let arrItem = [...newArr, newOdj]
        setSelectDomain(arrItem);
    };
    const removeDomain = (index) => {
        let arrItem = selectDomain;
        if (arrItem.length > 1) {
            arrItem.splice(index, 1);
        }
        setSelectDomain([...arrItem]);
    };

    const handleInputValue = (index, name, value) => {
        let arr = [...selectDomain]
        arr[index] = value
        setSelectDomain([...arr])
    }
    const handleSelectDomain = (index, value) => {
        let arr = [...selectDomain]
        arr[index] = value
        setSelectDomain([...arr])
        setDomainListShow('');
    }

    return (
        < div className="card-body">
            <form>
                <div className="form-group">
                    <div>
                        <div>
                            <div className="drop_header_dflex">
                                <div>Select Domain</div>
                                <span className="text-info-message">You can select 4 domain</span>
                                <span></span>
                            </div>
                        </div>
                        {selectDomain &&
                            <div className="mt-4">
                                {selectDomain.length >= 0 && selectDomain.map((item, index) => (
                                    <div>
                                        <div className="row new_fild_shadow">
                                            <div className="col-lg-6">
                                                <div className="input-field-box">
                                                    <label className="forn_title">
                                                        Domain name {selectDomain.length >= 2 && index + 1} :
                                                    </label>
                                                    <input
                                                        placeholder="Enter Domain"
                                                        className="form-control border-dark"
                                                        value={item}
                                                        onChange={(e) => { handleInputValue(index, 'Domain', e.target.value); setDomainListShow(index) }}
                                                    />
                                                    {domainListShow === index && domainList.length > 0 &&
                                                        <ul className="domain_list_box" ref={wrapperRef}>
                                                            {domainList.map((item, i) => (
                                                                <li className="dmn_item" key={i}><a onClick={() => handleSelectDomain(index, item)}>{item}</a></li>
                                                            ))}
                                                        </ul>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-lg-2">
                                                <div className="d-flex">
                                                    {index > 0 && (
                                                        <div className="sav-proj-btn">
                                                            <button className="cancel-btn_ btn_danger" onClick={() => removeDomain(index)} type="button">
                                                                Remove
                                                            </button>
                                                        </div>
                                                    )}
                                                    {index === 0 && selectDomain.length < 4 && (
                                                        <div className="sav-proj-btn">
                                                            <button className="sub-btn" onClick={addNewDomain} type="button" >Add More</button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="sav-proj-btn">
                                    <button className="sub-btn" onClick={() => setDomainSelectShow(2)} type="button">Submit</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </form>
        </div>
    );
}
export default Domain;
